module.exports = __webpack_public_path__ + "img/Momentum_Knok_Pairing-Mode.2d6fe0b7.png";